import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BackendOberflaecheService, ClientDownloadService, SidebarService, ModalService } from '@vhv/tarifrechner-common';
import { HttpClient } from '@angular/common/http';
import { SendeAntragsdatenCyberService } from './sende-antragsdaten-cyber.service';
import { AppConfiguration } from '../app/app.configuration';

@Injectable({
    providedIn: 'root',
})
export class PreisvorschlagCyberService {

    private readonly seiteJahresbeitragRoute = '/beitrag/Jahresumsatz';
    private readonly seitePreisuebersichtRoute = '/beitragErgebnis/Preis';
    private readonly seiteVorPreisuebersichtRoute = '/beitragRate/Hackerangriffe';
    private readonly seiteDankeRoute = '/danke/Danke';

    private readonly preisvorschlagPdfDateiname = 'Preisvorschlag_VHV_CYBERPROTECT.pdf';

    constructor(
        private readonly router: Router,
        private readonly http: HttpClient,
        private readonly conf: AppConfiguration,
        private readonly sendeAntragsdatenService: SendeAntragsdatenCyberService,
        private readonly backendOberflaecheService: BackendOberflaecheService,
        private readonly clientDownloadService: ClientDownloadService,
        private readonly sidebarService: SidebarService,
        private readonly modalService: ModalService
    ) {
        this.onRouteChange();
    }

    public preisvorschlagHerunterladen(): void {
        const antragRequest = this.sendeAntragsdatenService.getDownloadRequest();
        const preisvorschlagDownloadUrl = this.conf.restParentPath + this.conf.restPaths.pdfPreisvorschlag.path;

        this.http.post(preisvorschlagDownloadUrl, antragRequest).subscribe(
            (response: { data: { blob: string }}) => {
                this.clientDownloadService.providePdfDownload(
                    response.data.blob,
                    this.preisvorschlagPdfDateiname
                );
            },
            error => {
                this.modalService.showDialog(
                    'Fehler',
                    'Aufgrund eines internen Fehlers kann die Preisvorschlag-Datei nicht gesendet werden. Wir entschuldigen uns für die Unannehmlichkeiten.'
                );
                console.error(error);
            },
        );
    }

    private onRouteChange(): any {
        this.router.events.subscribe((routeChange) => {
            if (!(routeChange instanceof NavigationStart)) {
                return;
            }

            if (routeChange.url === this.seiteJahresbeitragRoute) {
                this.eingabenSichernButtonZeigen();
            } else if (routeChange.url === this.seitePreisuebersichtRoute && this.isDirektionsanfrage()) {
                // Zeige Preisvorschlag ab der ersten Übersichtsseite (Preisübersicht)
                this.preisvorschlagButtonZeigen()
            } else if (routeChange.url === this.seiteVorPreisuebersichtRoute) {
                // Verstecke Preisvorschlag beim Zurückgehen
                this.preisvorschlagButtonVerstecken();
            } else if (routeChange.url === this.seiteDankeRoute) {
                // Ab der Danke-Seite muss der Preisvorschlag auch nicht mehr gezeigt werden
                this.preisvorschlagButtonVerstecken();
            }
        });
    }

    private isDirektionsanfrage() {
        return this.backendOberflaecheService.getElementByName('IstDirektionsanfrage').value !== 'true';
    }

    private eingabenSichernButtonZeigen(): void {
        this.sidebarService.eingabenSichernButtonSichtbarkeitEvent.next({
            sollSichtbarSein: true
        });
    }

    private preisvorschlagButtonZeigen(): void {
        this.sidebarService.preisvorschlagButtonSichtbarkeitEvent.next({
            sollSichtbarSein: true
        });
    }

    private preisvorschlagButtonVerstecken(): void {
        this.sidebarService.preisvorschlagButtonSichtbarkeitEvent.next({
            sollSichtbarSein: false
        });
    }

}
